import PropTypes from 'prop-types';
import React from 'react';
import { ReactComponent as Sun } from '../../images/sun.svg';
import cx from 'classnames';
import { ReactComponent as DarkSun } from '../../images/dark-sun.svg';

const PROCESSING_ICONS = {
  darkSun: <DarkSun className="dark-sun-icon icon" />,
  sun: <Sun name="sun" className="sun-icon icon" />,
};

const ActionWithLoading = ({
  onClick,
  linkButton,
  processing,
  children,
  alt,
  classNames,
  buttonType = 'submit',
  primary,
  disabled,
  processingIconName,
  ...others
}) => (
  <button
    disabled={disabled}
    type={buttonType}
    {...others}
    className={
      linkButton
        ? 'button-link link-button'
        : cx({ 'action-primary': primary !== false }, classNames, { processing, 'action-alt': alt })
    }
    onClick={(e) => {
      if (processing) {
        e.preventDefault();
      } else if (typeof onClick === 'function') {
        onClick(e);
      }
    }}
  >
    <div className={linkButton ? '' : 'action-contents'}>{children}</div>
    {processing && (
      <div className="processing-icon">{PROCESSING_ICONS[processingIconName] || PROCESSING_ICONS.sun}</div>
    )}
  </button>
);

ActionWithLoading.propTypes = {
  onClick: PropTypes.func,
  linkButton: PropTypes.bool,
  processing: PropTypes.bool,
  children: PropTypes.any,
  alt: PropTypes.bool,
  classNames: PropTypes.string,
  buttonType: PropTypes.string,
  primary: PropTypes.bool,
  disabled: PropTypes.bool,
  processingIconName: PropTypes.string,
};

export default ActionWithLoading;
